export default __webpack_public_path__ + "f5c1b7ffff68d31b846ecfc72a27a7e4.png";